import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { deleteMappingAction, updateMappingAction } from '../../redux/actions/upcScanActions';

const MappingButtons = ({ mapping, validateBarcode }) => {


    const dispatch = useDispatch()
    const { message } = useSelector(state => state.mapping)


    const [showUpdateSection, SetShowUpdateSection] = useState(false)
    const [showPopup, setShowPopup] = useState(false)
    const [parent_barcode, setParent_barcode] = useState("");
    const [child_barcode, setChild_barcode] = useState("");
    const [unit_case, setUnit_Case] = useState("");



    useEffect(() => {
        setParent_barcode(mapping.parent_barcode)
        setChild_barcode(mapping.child_barcode)
        setUnit_Case(mapping.unit_case)
    }, [mapping])



    const handleSubmit = (e) => {

        e.preventDefault();

        if (!parent_barcode) {
            toast.error("Please enter case barcode");
            return;
        }

        if (!child_barcode) {
            toast.error("Please enter item barcode");
            return;
        }

        if (!unit_case) {
            toast.error("Please enter units per case");
            return;
        }
        if (Number(unit_case) < 1) {
            toast.error("Please enter valid units per case");
            return;
        }

        // ✅ Validate Parent Barcode
        const parentValidation = validateBarcode(parent_barcode);

        if (!parentValidation.success) {
            toast.error(parentValidation.message);
            return;
        }

        // ✅ Validate Child Barcode
        const childValidation = validateBarcode(child_barcode);

        if (!childValidation.success) {
            toast.error(childValidation.message);
            return;
        }

        const data = {
            parent_barcode: parentValidation.barcode,
            child_barcode: childValidation.barcode,
            unit_case,
            mapping_id: mapping.id
        };

        dispatch(updateMappingAction(data));
    };


    useEffect(() => {
        if (message) {
            SetShowUpdateSection(false);
            setShowPopup(false)
        }
    }, [message])


    const handleDelete = () => {


        dispatch(deleteMappingAction( mapping.id))

    }


    return (
        <Fragment>
            <button
                onClick={() => SetShowUpdateSection(true)}
            >
                <i className="fa-regular fa-pen-to-square text-[1.5vmax] text-green-500"></i>
            </button>
            <button
                onClick={() => setShowPopup(true)}

            >
                <i className="fa-regular fa-trash-can text-[1.5vmax] text-red-600"></i>
            </button>
            {
                showUpdateSection &&
                <section className="fixed top-0 left-0 w-screen h-screen bg-black/50 z-[9999999] flex justify-center items-center">
                    <div className="w-[35%] flex flex-col gap-[0.5vmax] relative bg-white shadow-1 p-[1.5vmax] rounded-2xl">
                        <button className='absolute top-[1.5vmax] right-[1.5vmax] text-[2vmax] text-gray-600'
                            onClick={() => SetShowUpdateSection(false)}
                        >
                            <i className="fa-regular fa-xmark-circle"></i>
                        </button>
                        <h2 className="text-[1.5vmax] font-2 font-bold py-[2vmax]" >Add New Barcode Mapping</h2>
                        <div className="w-[70%] mx-auto flex flex-col gap-[0.8vmax]">
                            <div className=" w-full flex flex-col gap-[0.5vmax]">
                                <span className="text-[1vmax] font-[600] text-gray-600" >Case Barcode &nbsp;
                                    <span className="text-red-600" >*</span>
                                </span>
                                <input type="number" className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]" placeholder="Case Barcode"
                                    value={parent_barcode}
                                    onChange={(e) => setParent_barcode(e.target.value)}
                                />
                            </div>
                            <div className=" w-full flex flex-col gap-[0.5vmax]">
                                <span className="text-[1vmax] font-[600] text-gray-600" >
                                    Units per Case&nbsp;
                                    <span className="text-red-600" >*</span>
                                </span>
                                <input type="number" className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]" placeholder=" Unit / Case"
                                    value={unit_case}
                                    onChange={(e) => setUnit_Case(e.target.value)}
                                />
                            </div>
                            <div className=" w-full flex flex-col gap-[0.5vmax]">
                                <span className="text-[1vmax] font-[600] text-gray-600" >
                                    Item Barcode
                                    &nbsp;
                                    <span className="text-red-600" >*</span>
                                </span>
                                <input type="number" className="p-[0.8vmax_1vmax] border-[0.15vmax] border-slate-300 rounded-xl outline-[var(--color-2)]" placeholder="Item barcode"
                                    value={child_barcode}
                                    onChange={(e) => setChild_barcode(e.target.value)}
                                />
                            </div>
                        </div>
                        <button className="bg-[image:var(--gradient-2)] w-[70%] mx-auto mt-[1.5vmax] text-white p-[0.7vmax] text-[1.2vmax] rounded-2xl"
                            onClick={handleSubmit}
                        >
                            Save
                        </button>
                    </div>
                </section>
            }
            {
                showPopup &&
                <section className="fixed top-0 left-0 w-screen h-screen bg-black/50 z-[9999999] flex justify-center items-center">
                    <div className="w-[35%] flex flex-col gap-[0.5vmax] relative bg-white shadow-1 p-[1.5vmax] rounded-2xl">
                        <button className='absolute top-[1.5vmax] right-[1.5vmax] text-[2vmax] text-gray-600'
                            onClick={() => SetShowUpdateSection(false)}
                        >
                            <i className="fa-regular fa-xmark-circle"></i>
                        </button>
                        <h2 className="text-[1.5vmax] font-2 font-bold pt-[2vmax]" >Delete this Barcode mapping</h2>
                        <p className="mb-[1.5vmax] text-[1vmax]">
                            Are you sure you want to delete this mapping.
                        </p>
                        <div className="flex justify-end gap-[1.5vmax]">
                            <button className="bg-gray-400 w-fit   text-white p-[0.7vmax_1.5vmax] text-[1.2vmax] rounded-2xl"
                                onClick={() => setShowPopup(false)}
                            >
                                Cancel
                            </button>
                            <button className="bg-[image:var(--gradient-2)] text-white p-[0.7vmax_1.5vmax] text-[1.2vmax] rounded-2xl"
                                onClick={handleDelete}
                            >
                                Yes
                            </button>
                        </div>
                    </div>
                </section>
            }
        </Fragment>
    )
}

export default MappingButtons
